// TODO: Componetize corresponding stylesheets for varian-swatches.js and quick-add.js
class VariantSwatch extends HTMLButtonElement {
  constructor() {
    super();
    this.productId = this.dataset.productid;
    this.variantId = this.dataset.variantid;
    this.variantIsAvailable = this.dataset.available;
    this.associatedImageId = `card__image--variant-${this.variantId}`;
    this.isSelected =
      this.getAttribute("data-selected-variant") === "true" ? true : false;
    this.addEventListener("click", this.handleVariantChange);
  }

  handleQuickAdd() {
    const quickAddBtn = document.querySelector(
      `#card--${this.productId} button[is='quick-add-button']`
    );
    if (quickAddBtn) {
      quickAddBtn.updateVariantId(this.variantId);
      quickAddBtn.handleButtonText(this.variantIsAvailable);
    }
  }

  handleImageChange(currentlySelectedVariant) {
    const currentVariantImage = document.getElementById(
      `card__image--variant-${currentlySelectedVariant.variantId}`
    );
    if (currentVariantImage) {
      currentVariantImage.classList.add("card__image-variant--hidden");
    }

    const updatedVariantImage = document.getElementById(
      `${this.associatedImageId}`
    );
    if (updatedVariantImage) {
      updatedVariantImage.classList.remove("card__image-variant--hidden");
    }
  }

  handleLinkChange() {
    const cardURL = document.getElementById(
      `card__product-link-${this.productId}`
    );
    if (cardURL) {
      cardURL.href = this.dataset.url;
    }

    const cardLinkTarget = document.getElementById(
      `card__link-target--${this.productId}`
    );
    if (cardLinkTarget) {
      cardLinkTarget.href = this.dataset.url;
    }
  }

  findCurrentVariant() {
    const currentlySelectedVariant = document.querySelector(
      `#card__color-swatches--${this.productId} .card__color-swatch-button[data-selected-variant=true]`
    );
    if (currentlySelectedVariant) {
      currentlySelectedVariant.removeAttribute("data-selected-variant");
      currentlySelectedVariant.isSelected = false;
      return currentlySelectedVariant;
    }
  }

  handleVariantChange() {
    if (this.isSelected === true) {
      return;
    } else {
      const currentVariant = this.findCurrentVariant();
      if (currentVariant) {
        this.handleImageChange(currentVariant);
        this.handleLinkChange();
        this.setAttribute("data-selected-variant", true);
        this.isSelected = true;
        this.handleQuickAdd();
      }
    }
  }
}

if (!customElements.get("collection-variant-swatch")) {
  customElements.define("collection-variant-swatch", VariantSwatch, {
    extends: "button",
  });
}
